import React from 'react';
import img from '../../images/img1.jpg'

const Image = () => {
    return (
        <div>
            <img className='img-fluid mt-1 mb-3' src={img} alt="" />
        </div>
    );
};

export default Image;